/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Learn_TitleInputs */

const en_home_learn_title = /** @type {(inputs: Home_Learn_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn CADCraft in minutes`)
};

/**
* | output |
* | --- |
* | "Learn CADCraft in minutes" |
*
* @param {Home_Learn_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_learn_title = /** @type {((inputs?: Home_Learn_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Learn_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_learn_title(inputs)
});
export { home_learn_title as "home.learn.title" }